import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Tracking } from 'bdvp-tracking';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import Btn from '@mlb/react-patterns/components/Button/button.tsx';

const TYPE_NEXT = 'next', TYPE_PREVIOUS = 'previous';

const Button = styled(Btn).attrs(({ iconName }) => ({
    size: 'md',
    iconName: iconName,
    iconLeft: false,
    shape: 'hollow-borderless',
    styleName: 'default',
    iconSize: 25,
    hasHover: false,
}))`
    {
        display: inline-block;
        position: relative;
        left: ${({ left }) => left ? 'auto' : '10px'};
        right: ${({ right }) => right ? 'auto' : '10px'};

        &[disabled] {
            opacity: 0.5;
        }

        ${media.mdmin`
            @media (orientation: landscape) {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }
        `}

    }
`;

const PreviousNextButton = ({
    ariaLabel,
    disabled,
    iconName,
    left,
    right,
    onClickHandler,
    isNextButton,
}) => {

    const type = (isNextButton ? TYPE_NEXT : TYPE_PREVIOUS);

    return (
        <Button
            ariaLabel={ariaLabel || type}
            disabled={disabled}
            iconName={iconName}
            {...(left && { left })}
            {...(right && { right })}
            handlers={
                {
                    onClick: () => {

                        Tracking.trackLightboxPreviousNextClick(type.charAt(0).toUpperCase() + type.slice(1));

                        onClickHandler();

                    },
                }
            }
        />
    );

};

PreviousNextButton.propTypes = {
    ariaLabel: PropTypes.string,
    disabled: PropTypes.bool,
    iconName: PropTypes.string.isRequired,
    left: PropTypes.bool,
    right: PropTypes.bool,
    onClickHandler: PropTypes.func.isRequired,
    isNextButton: PropTypes.bool,
};


PreviousNextButton.defaultProps = {
    ariaLabel: '',
    disabled: false,
    left: false,
    right: false,
    isNextButton: false,
};
export default PreviousNextButton;
